import React, { useState, useEffect } from 'react';
import { useControleDemanda } from '../context/ControleDemandaProvider';
import { useAuth } from '../../shared/context/AuthContext';
import ModalEncaminhar from './ModalEncaminhar';
import ModalResposta from './ModalResposta';
import HistoricoDemanda from './HistoricoDemanda';
import ImagemDemanda from './ImagemDemanda';
import MapaDemandaFixed from './MapaDemandaFixed';

export default function DetalhesDemanda({ demanda, onVoltar }) {
  const { 
    concluirDemanda,
    buscarHistoricoDemanda
  } = useControleDemanda();
  
  const { user } = useAuth();
  const [showModalEncaminhar, setShowModalEncaminhar] = useState(false);
  const [showModalResposta, setShowModalResposta] = useState(false);
  const [showHistorico, setShowHistorico] = useState(false);
  const [historico, setHistorico] = useState([]);

  useEffect(() => {
    carregarHistorico();
  }, [demanda.id]);

  const carregarHistorico = async () => {
    const hist = await buscarHistoricoDemanda(demanda.id);
    setHistorico(hist);
  };

  const formatarData = (data) => {
    if (!data) return 'N/A';
    return new Date(data).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getOrigemInfo = () => {
    if (demanda.tipo_usuario_origem === 1) {
      return {
        icon: 'fas fa-mobile-alt',
        text: 'Aplicativo',
        class: 'origem-app'
      };
    }
    if (demanda.tipo_usuario_origem === 2) {
      return {
        icon: 'fab fa-whatsapp',
        text: 'WhatsApp',
        class: 'origem-whatsapp'
      };
    }
    return {
      icon: 'fas fa-question',
      text: 'Não identificado',
      class: 'origem-unknown'
    };
  };

  const handleConcluir = async () => {
    if (window.confirm('Tem certeza que deseja concluir esta demanda?')) {
      await concluirDemanda(demanda.id, user.id);
      onVoltar();
    }
  };

  const origem = getOrigemInfo();
  
  // Usar IDs dos status conforme STATUS_CORRETOS.md
  const statusId = demanda.status_id;
  
  // Debug: verificar valores
  console.log('🔍 Debug DetalhesDemanda:', {
    status_nome: demanda.status_nome,
    status_id: demanda.status_id,
    demanda_completa: demanda
  });
  
  // Status IDs corretos:
  // 1 = RECEBIDO, 2 = CONCLUÍDO, 3 = ENCAMINHADO, 4 = ANÁLISE
  const estaEncaminhada = statusId === 3; // ENCAMINHADO
  const estaConcluida = statusId === 2;   // CONCLUÍDO
  const estaEmAnalise = statusId === 4;   // ANÁLISE
  
  const podeEncaminhar = !estaEncaminhada && !estaConcluida;
  const podeResponder = !estaEncaminhada && !estaConcluida;
  const podeConcluir = !estaConcluida;
  
  console.log('🔍 Debug Condições:', {
    statusId,
    estaEncaminhada,
    estaConcluida,
    estaEmAnalise,
    podeEncaminhar,
    podeResponder,
    podeConcluir
  });

  return (
    <div className="detalhes-demanda">
      <div className="detalhes-header">
        <button className="btn-voltar" onClick={onVoltar}>
          <i className="fas fa-arrow-left"></i>
          Voltar
        </button>
        <div className="demanda-titulo">
          <h2>Demanda #{demanda.protocolo || demanda.id}</h2>
          <div className={`origem-badge ${origem.class}`}>
            <i className={origem.icon}></i>
            {origem.text}
          </div>
        </div>
      </div>

      <div className="detalhes-content">
        <div className="detalhes-main">
          <div className="info-section">
            <h3>Informações Gerais</h3>
            <div className="info-grid">
              <div className="info-item">
                <label>Categoria:</label>
                <span>{demanda.categoria_nome || 'Não informada'}</span>
              </div>
              <div className="info-item">
                <label>Status:</label>
                <span className={`status-badge status-${demanda.status_nome?.toLowerCase().replace(' ', '-') || 'novo'}`}>
                  {demanda.status_nome || 'Novo'}
                </span>
              </div>
              <div className="info-item">
                <label>Prioridade:</label>
                <span className={`prioridade-badge prioridade-${demanda.prioridade?.toLowerCase() || 'normal'}`}>
                  {demanda.prioridade || 'Normal'}
                </span>
              </div>
              <div className="info-item">
                <label>Data de Criação:</label>
                <span>{formatarData(demanda.created_at)}</span>
              </div>
              <div className="info-item">
                <label>Última Atualização:</label>
                <span>{formatarData(demanda.dataultimaatualizacao || demanda.updated_at)}</span>
              </div>
              <div className="info-item">
                <label>Solicitante:</label>
                <span>{demanda.usuario_nome || 'Não identificado'}</span>
              </div>
              <div className="info-item">
                <label>Origem:</label>
                <span>
                  {demanda.tipo_usuario_origem === 1 ? (
                    <><i className="fas fa-mobile-alt" style={{marginRight: '5px', color: '#27ae60'}}></i>Aplicativo Móvel</>
                  ) : demanda.tipo_usuario_origem === 2 ? (
                    <><i className="fab fa-whatsapp" style={{marginRight: '5px', color: '#25d366'}}></i>WhatsApp</>
                  ) : (
                    'Não identificado'
                  )}
                </span>
              </div>
            </div>
          </div>

          {/* Seção específica para demandas de iluminação pública (categoria 1) */}
          {demanda.categoria_id === 1 && (demanda.numero_poste || demanda.latitude_poste || demanda.longitude_poste) && (
            <div className="info-section">
              <h3>
                <i className="fas fa-lightbulb" style={{ marginRight: '8px', color: '#ff6f00' }}></i>
                Informações do Poste
              </h3>
              <div className="info-grid">
                {demanda.numero_poste && (
                  <div className="info-item">
                    <label>Número do Poste:</label>
                    <span className="poste-numero">
                      <i className="fas fa-hashtag" style={{ marginRight: '5px', color: '#ff6f00' }}></i>
                      {demanda.numero_poste}
                    </span>
                  </div>
                )}
                {demanda.latitude_poste && demanda.longitude_poste && (
                  <div className="info-item">
                    <label>Coordenadas do Poste:</label>
                    <span className="coordenadas-poste">
                      <i className="fas fa-map-marker-alt" style={{ marginRight: '5px', color: '#ff6f00' }}></i>
                      {parseFloat(demanda.latitude_poste).toFixed(6)}, {parseFloat(demanda.longitude_poste).toFixed(6)}
                    </span>
                  </div>
                )}
              </div>
              
              {/* Mini mapa do poste */}
              {demanda.latitude_poste && demanda.longitude_poste && (
                <div className="poste-mapa-container" style={{ marginTop: '15px' }}>
                  <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#666' }}>
                    <i className="fas fa-map" style={{ marginRight: '6px' }}></i>
                    Localização do Poste
                  </h4>
                  <div style={{ height: '200px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #ddd' }}>
                    <MapaDemandaFixed 
                      latitude={parseFloat(demanda.latitude_poste)} 
                      longitude={parseFloat(demanda.longitude_poste)}
                      showPosteIcon={true}
                      posteNumero={demanda.numero_poste}
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="info-section">
            <h3>Descrição</h3>
            <div className="descricao-content">
              <p>{demanda.descricao || 'Sem descrição'}</p>
            </div>
          </div>

          <div className="info-section">
            <h3>Localização</h3>
            <div className="localizacao-grid-balanced">
              {/* Informações de endereço */}
              <div className="endereco-info">
                <div className="endereco-item">
                  <strong>Endereço:</strong> {demanda.endereco || 'Não informado'}
                </div>
                <div className="endereco-item">
                  <strong>Ponto de Referência:</strong> {demanda.pontodereferencia || 'Não informado'}
                </div>
                <div className="endereco-item">
                  <strong>Bairro:</strong> {demanda.bairro || 'Não informado'}
                </div>
                {(demanda.coordenada || demanda.google_maps_url) && (
                  <div className="endereco-item">
                    <strong>Coordenadas:</strong> {demanda.coordenada || (() => {
                      const patterns = [
                        /place\/(-?\d+\.?\d*),(-?\d+\.?\d*)/,
                        /@(-?\d+\.?\d*),(-?\d+\.?\d*)/,
                        /q=(-?\d+\.?\d*),(-?\d+\.?\d*)/
                      ];
                      for (const regex of patterns) {
                        const match = demanda.google_maps_url.match(regex);
                        if (match) return `${parseFloat(match[1]).toFixed(6)}, ${parseFloat(match[2]).toFixed(6)}`;
                      }
                      return 'Não disponível';
                    })()}
                  </div>
                )}
              </div>
              
              {/* Mapa da localização */}
              <div className="mapa-container" style={{ minWidth: '200px', width: '100%' }}>
                <MapaDemandaFixed 
                  demanda={demanda} 
                  height="100%"
                />
              </div>
            </div>
          </div>



          {demanda.imagem && (
            <div className="info-section">
              <h3>Imagem da Demanda</h3>
              <div className="imagem-content">
                <ImagemDemanda 
                  src={demanda.imagem} 
                  alt="Imagem da demanda"
                  width="300px"
                  height="200px"
                />
              </div>
            </div>
          )}

          {demanda.resposta && (
            <div className="info-section">
              <h3>Resposta</h3>
              <div className="resposta-content">
                <p>{demanda.resposta}</p>
                <div className="resposta-info">
                  <small>
                    Respondido em: {formatarData(demanda.dataResposta)}
                  </small>
                </div>
              </div>
            </div>
          )}

          {(demanda.url_imagem_solucao || demanda.descricao_solucao) && (
            <div className="info-section">
              <h3>Solução</h3>
              <div className="solucao-content">
                {demanda.descricao_solucao && (
                  <p>{demanda.descricao_solucao}</p>
                )}
                {demanda.url_imagem_solucao && (
                  <div className="imagem-content">
                    <ImagemDemanda 
                      src={demanda.url_imagem_solucao} 
                      alt="Imagem da solução"
                      width="300px"
                      height="200px"
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          {demanda.funcionario_encaminhamento_preenchido && (
            <div className="info-section">
              <h3>Encaminhamento</h3>
              <div className="encaminhamento-content">
                <div className="info-item">
                  <label>Funcionário:</label>
                  <span>{demanda.funcionario_encaminhamento_nome || 'N/A'}</span>
                </div>
                <div className="info-item">
                  <label>Setor:</label>
                  <span>{demanda.setor_encaminhamento_descricao || 'N/A'}</span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="detalhes-sidebar">
          <div className="acoes-section">
            <h3>Ações</h3>
            <div className="acoes-buttons">
              {podeResponder && (
                <button
                  className="btn btn-primary"
                  onClick={() => setShowModalResposta(true)}
                >
                  <i className="fas fa-reply"></i>
                  Responder
                </button>
              )}
              
              {podeEncaminhar && (
                <button
                  className="btn btn-warning"
                  onClick={() => setShowModalEncaminhar(true)}
                >
                  <i className="fas fa-share"></i>
                  Encaminhar
                </button>
              )}
              
              {podeConcluir && (
                <button
                  className="btn btn-success"
                  onClick={handleConcluir}
                >
                  <i className="fas fa-check"></i>
                  Concluir
                </button>
              )}
            </div>
          </div>

          <div className="historico-section">
            <h3>Histórico</h3>
            <button
              className="btn btn-outline"
              onClick={() => setShowHistorico(!showHistorico)}
            >
              <i className="fas fa-history"></i>
              {showHistorico ? 'Ocultar' : 'Ver'} Histórico
            </button>
            
            {showHistorico && (
              <HistoricoDemanda historico={historico} />
            )}
          </div>
        </div>
      </div>

      {showModalEncaminhar && (
        <ModalEncaminhar
          demanda={demanda}
          onClose={() => setShowModalEncaminhar(false)}
          onSuccess={() => {
            setShowModalEncaminhar(false);
            onVoltar();
          }}
        />
      )}

      {showModalResposta && (
        <ModalResposta
          demanda={demanda}
          onClose={() => setShowModalResposta(false)}
          onSuccess={() => {
            setShowModalResposta(false);
            carregarHistorico();
          }}
        />
      )}
    </div>
  );
}